const getFecha = () => {
  let date = new Date()
  let year = date.getFullYear().toString()
  let month = (date.getMonth() + 101).toString().substring(1)
  let day = (date.getDate() + 100).toString().substring(1)

  let fecha = year + "-" + month + "-" + day
  return fecha
}

export default getFecha
